var chunkToChildrenMap = {
	"front-office-components": [
		"common",
		"froala",
		"back-office_templates",
		"back-office"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));